import * as m from "@paraglide/messages"
import type { SupportedLocale } from "@playbrain/content-types"
import PlaydataFooter from "@playdata/PlaydataFooter"
import PlaydataHeader from "@playdata/PlaydataHeader"
import type { ReactNode } from "react"

/**
 * Shell for every microsite page.
 *
 * Deliberately not PageLayout: that carries the PLAYBRAIN side menu, footer and
 * background, and the microsite has its own chrome. The only thing the two
 * share is the design token layer in global.css.
 */
export function PlaydataLayout({ children, locale }: { children: ReactNode; locale: SupportedLocale }) {
  return (
    <div className="playdata-shell">
      <div className="playdata-surface flex flex-col">
        <a
          href="#playdata-main"
          className="sr-only focus:not-sr-only focus:absolute focus:z-30 focus:m-[1rem] focus:bg-play-white focus:px-[1.2rem] focus:py-[0.6rem] focus:text-play-black"
        >
          {m.playdata_a11y_skipToContent({}, { locale })}
        </a>
        <PlaydataHeader locale={locale} />
        <main
          id="playdata-main"
          className="flex-1"
        >
          {children}
        </main>
        <PlaydataFooter locale={locale} />
      </div>
    </div>
  )
}

export default PlaydataLayout
